import { Component, input } from '@angular/core';

@Component({
  selector: 'empathy-viewer-progress-bar',
  templateUrl: 'progress-bar.component.html',
  styleUrls: ['progress-bar.component.scss']
})
export class EmpathyViewerProgressBarComponent {
  color = input<'primary' | 'accent'>('accent');
  progress = input<number>(0);
}
